import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useGetQualificationList = (userId) => {
  const data = useQuery(
    ["qualificationList", userId],
    () =>
      axiosClient.get(
        `/DocumentType/GetQualificationsList?userId=${userId}`
      ),
  );

  return data;
};
export default useGetQualificationList;